const autogrowTextareas = (e) => {
  if (!e.target.closest('.autogrow-wrapper')) return;

  e.target.closest('.autogrow-wrapper').dataset.textareaValue = e.target.value;
}

document.addEventListener('input', autogrowTextareas);
